import SegmentTracking from './segmentTracking';
import UserpilotTracking from './userpilotTracking';
import PosthogTracking from './posthogTracking';
const TRACKER_CLASSES = [
    SegmentTracking,
    UserpilotTracking,
    PosthogTracking,
];
export default class TrackingDispatcher {
    constructor(...args) {
        this.trackers = TRACKER_CLASSES.map((TrackerClass) => new TrackerClass(...args));
        this.$log = args[2];
    }
    initProvider(...args) {
        this.executeForAllTrackers('initProvider', ...args);
    }
    identifyUser(...args) {
        this.executeForAllTrackers('identifyUser', ...args);
    }
    unidentifyUser(...args) {
        this.executeForAllTrackers('unidentifyUser', ...args);
    }
    track(...args) {
        this.executeForAllTrackers('track', ...args);
    }
    trackButtonClick(...args) {
        this.executeForAllTrackers('trackButtonClick', ...args);
    }
    trackWithoutParams(...args) {
        this.executeForAllTrackers('trackWithoutParams', ...args);
    }
    trackWithExplicitProperties(...args) {
        this.executeForAllTrackers('trackWithExplicitProperties', ...args);
    }
    trackPageView(...args) {
        this.executeForAllTrackers('trackPageView', ...args);
    }
    trackScreenshare(...args) {
        this.executeForAllTrackers('trackScreenshare', ...args);
    }
    // ===========================================================================
    // Private methods
    // ===========================================================================
    executeForAllTrackers(methodName, ...args) {
        for (const tracker of this.trackers) {
            try {
                tracker[methodName](...args);
            }
            catch (error) {
                this.$log.error(`Error while executing ${methodName} on tracker ${tracker.constructor.name}.`, error);
            }
        }
    }
}
